<app-table-virtual-scroll-viewport [style.height]="height || 'calc(100vh - 216px)'">
    <table
        aria-describedby="virtual table"
        mat-table
        [dataSource]="virtualDataSource"
        multiTemplateDataRows
        class="pAdjust mat-elevation-z2 matTableContainer"
        [trackBy]="trackRecord">
        <ng-container [matColumnDef]="columnId" *ngFor="let columnId of selectedColumns">
            <ng-container [ngSwitch]="columnKeyPair[columnId]?.type">
                <ng-container *ngSwitchCase="'text'">
                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader" [title]="columnKeyPair[columnId]?.name">
                        <span [textContent]="columnKeyPair[columnId]?.name | pascalToCamel"></span>
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="matTableCell"
                        [title]="element[columnId] || '--'"
                        (click)="copyToInboundRequestId(element)">
                        <span
                            [class.dataTypeTextAlign]="
                                ['INT', 'LONG', 'FLOAT', 'DOUBLE', 'DECIMAL'].includes(columnKeyPair[columnId]?.inputType)
                            "
                            [textContent]="element[columnId]"></span>
                    </td>
                </ng-container>
                <ng-container *ngSwitchCase="'SELECTRECORD'">
                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                        <ng-container *ngIf="columnKeyPair[columnId].showCheckboxInHeader">
                            <material-checkbox
                                [badge]="
                                    selectedRecordsCount > 0 && !columnKeyPair[columnId].hideCheckboxBadge ? selectedRecordsCount : null
                                "
                                (modelChange)="toggleRecordsSelection($event)"
                                [(model)]="selectAllRecords"
                                [disabled]="hiddenRowCheckbox"
                                class="selectAllBtn"></material-checkbox>
                        </ng-container>
                        <ng-container *ngIf="!columnKeyPair[columnId].showCheckboxInHeader">
                            <span [textContent]="columnKeyPair[columnId]?.name"></span>
                        </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let element" class="matTableCell">
                        <material-checkbox
                            class="recordSelectCheckboxContainer"
                            [disabled]="hiddenRowCheckbox"
                            [(model)]="element.selected"
                            (modelChange)="onRecordSelectionChange(element)"></material-checkbox>
                    </td>
                </ng-container>
                <ng-container *ngSwitchCase="'select'"></ng-container>
                <ng-container *ngSwitchCase="'group-select'"></ng-container>
                <ng-container *ngSwitchCase="'ACCORDIAN'">
                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                        <span [textContent]="columnKeyPair[columnId]?.name"></span>
                    </th>
                    <td mat-cell *matCellDef="let element" class="matTableCell">
                        <div class="d-flex" *ngIf="element['accordian'] === false && element['fileName']">
                            <span
                                class="accordian_body_text"
                                (click)="onElementClick(element, element[columnId])"
                                [textContent]="element[columnId]"></span>
                        </div>
                        <mat-accordion class="tableColumnAccordian" *ngIf="element['accordian'] === true">
                            <mat-expansion-panel hideToggle #source>
                                <mat-expansion-panel-header>
                                    <div class="col-9 p-0">
                                        <mat-panel-title>
                                            <span
                                                class="accordian_body_text"
                                                (click)="$event.stopPropagation(); onElementClick(element, element[columnId][0])"
                                                [textContent]="element[columnId][0]"></span>
                                        </mat-panel-title>
                                    </div>
                                    <mat-icon class="title_icon" *ngIf="!source.expanded">add_circle_outline</mat-icon>
                                    <mat-icon class="title_icon" *ngIf="source.expanded">remove_circle_outline</mat-icon>
                                </mat-expansion-panel-header>
                                <div class="d-flex accordian_body" *ngFor="let accordian of element[columnId] | slice : 1">
                                    <span
                                        class="accordian_body_text"
                                        (click)="onElementClick(element, accordian)"
                                        [textContent]="accordian"></span>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </td>
                </ng-container>

                <ng-container *ngSwitchCase="'file'">
                    <th
                        scope="col"
                        mat-header-cell
                        *matHeaderCellDef
                        class="matTableHeader"
                        [textContent]="columnKeyPair[columnId]?.name"></th>
                    <td mat-cell *matCellDef="let element" class="matTableCell" (click)="$event.stopPropagation()">
                        <span class="tableFilesUploadContainer">
                            <app-file-upload
                                [data]="attachmentData"
                                [clearFiles]="clearFiles"
                                (newValue)="fileChanged($event, element)"
                                (fileName)="changedFileName($event, element)"></app-file-upload>
                        </span>
                        <span class="tableFilesName" [title]="element.fileName || '--'" [textContent]="element.fileName"></span>
                    </td>
                </ng-container>
                <ng-container *ngSwitchCase="'link'">
                    <th
                        scope="col"
                        mat-header-cell
                        *matHeaderCellDef
                        class="matTableHeader"
                        [textContent]="columnKeyPair[columnId]?.name"></th>
                    <td mat-cell *matCellDef="let element" class="matTableCell" (click)="$event.stopPropagation()">
                        <ng-container
                            [ngSwitch]="
                                element[columnId] &&
                                (element[columnId].indexOf('http://') > -1 || element[columnId].indexOf('https://') > -1)
                            ">
                            <ng-container *ngSwitchCase="true">
                                <span class="downloadLink" *transloco="let translate">
                                    <a [href]="element[columnId]" target="_blank" rel="noopener" [textContent]="translate('Download')"></a>
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <span
                                    class="downloadLink"
                                    (click)="downloadSourceTemplateUrl(element)"
                                    *transloco="let translate"
                                    [textContent]="translate('Download')"></span>
                            </ng-container>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="columnTypePair[columnId]">
                        <ng-container *ngSwitchCase="'ALL_COLUMNS_LIST'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader logMenuIcon">
                                <span class="material-icons logIcon" [matMenuTriggerFor]="logMenu">menu</span>
                                <mat-menu #logMenu="matMenu" [class]="'tableLogMenu !bg-white'" xPosition="after" yPosition="below">
                                    <div class="logMenu" stop-propagation *transloco="let translate">
                                        <div class="logFilter" stop-propagation>
                                            <mat-form-field>
                                                <input
                                                    matInput
                                                    class="filterInput"
                                                    autocomplete="off"
                                                    [placeholder]="translate('Filter Table Columns')"
                                                    [(ngModel)]="searchColumns" />
                                                <material-button
                                                    *ngIf="searchColumns"
                                                    buttonType="icon"
                                                    size="small"
                                                    [titleText]="'Clear'"
                                                    prefixIconType="material"
                                                    prefixIcon="close"
                                                    (buttonClicked)="searchColumns = ''"></material-button>
                                            </mat-form-field>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex justify-content-around align-items-center checkStyle" stop-propagation>
                                                <material-checkbox
                                                    [(model)]="selectAll"
                                                    (modelChange)="selectAllFilters($event)"
                                                    [name]="'Select All'"
                                                    [title]="'Select All'"
                                                    [showName]="true"
                                                    id="selectAllLabel"
                                                    [disabled]="false"></material-checkbox>
                                            </div>
                                            <material-button
                                                [color]="'primary'"
                                                [disabled]="clonedColumns.length === 0"
                                                [text]="translate('Apply')"
                                                (buttonClicked)="cloneSubmit()"></material-button>
                                        </div>
                                        <div
                                            class="logListItems"
                                            *ngFor="let column of allColumns; let i = index; trackBy: trackByAllColumnsMethod"
                                            stop-propagation
                                            [hidden]="
                                                !(
                                                    (!searchColumns ||
                                                        searchColumns.length === 0 ||
                                                        (searchColumns.length > 0 &&
                                                            column.name.toLowerCase().indexOf(searchColumns.toLowerCase()) > -1)) &&
                                                    actionColumns.indexOf(column.id) === -1 &&
                                                    !(hideTableColumns && hideTableColumns.indexOf(column.id) > -1)
                                                ) || column.hideInAllColumnsList
                                            ">
                                            <div class="d-flex align-items-center tempList">
                                                <div class="actionCheckBox mCheckbox">
                                                    <material-checkbox
                                                        [hidden]="column.type === 'SELECTRECORD' || column.name === 'dynamicActions'"
                                                        [model]="clonedColumns.indexOf(column.id) > -1"
                                                        (modelChange)="checkboxSelect($event, column)"
                                                        [name]="column.name"
                                                        [showName]="true"></material-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-menu>
                                <ng-container *ngIf="columnSearchRequired">
                                    <div class="searchHiddenDiv"></div>
                                </ng-container>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell"></td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'ACTIONS'">
                            <th
                                scope="col"
                                mat-header-cell
                                *matHeaderCellDef
                                class="matTableHeader alignCenter sticky-column !bg-[#f1f1f1]">
                                <div *transloco="let translate">
                                    <span [textContent]="translate('Actions')"></span>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell alignCenter sticky-column">
                                <div class="actionsMenu tableActionsMenu">
                                    <ng-container *ngFor="let action of recordActions; trackBy: trackByActionsMethod">
                                        <span [hidden]="!actionVisibility[element.recordId][action.displayName]">
                                            <ng-container
                                                *ngIf="
                                                    !action.conditionalDisplay ||
                                                    (action.byFieldValue &&
                                                        ((action.conditionType === 'NOT_EQUALS' &&
                                                            element[action.conditionalFieldId] !== action.conditionalFieldValue &&
                                                            !(
                                                                action.isArray &&
                                                                action.conditionalFieldValue.indexOf(element[action.conditionalFieldId]) >
                                                                    -1
                                                            )) ||
                                                            (action.conditionType === 'EQUALS' &&
                                                                element[action.conditionalFieldId] === action.conditionalFieldValue)))
                                                ">
                                                <material-button
                                                    buttonType="mini-fab"
                                                    [classList]="['!text-[#616161]']"
                                                    size="small"
                                                    prefixIconAppearance="filled"
                                                    [titleText]="action.displayName"
                                                    [disabled]="
                                                        action.iconName === 'remove_circle' &&
                                                        ((assetType !== 'BRIDGE_ASSET' &&
                                                            (element.instanceState === 'REQUEST_CANCELLED' ||
                                                                element.instanceState === 'REQUEST_COMPLETED' ||
                                                                element.requestState === 'Cancelled' ||
                                                                element.requestState === 'Completed')) ||
                                                            (assetType === 'BRIDGE_ASSET' &&
                                                                (element.instanceState === 'REQUEST_CANCELLED' ||
                                                                    element.requestState === 'Cancelled')))
                                                    "
                                                    prefixIconType="material"
                                                    [prefixIcon]="action.iconName"
                                                    [ngClass]="{ displayActionColor: action.iconName === 'warning' }"
                                                    (buttonClicked)="
                                                        action.onActionTrigger && action.onActionTrigger(element, action)
                                                    "></material-button>
                                            </ng-container>
                                        </span>
                                    </ng-container>
                                </div>
                                <ng-container *ngIf="!recordActions || recordActions.length === 0">
                                    <div *transloco="let translate">
                                        <material-button
                                            buttonType="icon"
                                            size="small"
                                            [titleText]="translate('No Actions Found')"></material-button>
                                    </div>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair[columnId]?.name"></span>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell" [textContent]="element[columnId]"></td>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td class="expandedTableRow" mat-cell *matCellDef="let element" [attr.colspan]="selectedColumns.length">
                <div class="example-element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"></div>
            </td>
        </ng-container>
        <ng-container matColumnDef="loading">
            <td mat-footer-cell class="matTableMessages tdFull" *matFooterCellDef colspan="100%">
                <div class="loaderBlock isLoading"></div>
            </td>
        </ng-container>
        <ng-container matColumnDef="noData">
            <div *transloco="let translate">
                <td mat-footer-cell class="matTableMessages" *matFooterCellDef colspan="100%">
                    <span [textContent]="noRecordMsg || translate('No records Found')"></span>
                </td>
            </div>
        </ng-container>
        <ng-container matColumnDef="noRecords">
            <div *transloco="let translate">
                <td
                    mat-footer-cell
                    class="matTableMessages noRecordMessage"
                    *matFooterCellDef
                    colspan="100%"
                    [textContent]="translate('No records found')"></td>
            </div>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="selectedColumns; sticky: true" [ngClass]="{ tableHeaderPadding: columnSearchRequired }"></tr>
        <tr
            mat-footer-row
            *matFooterRowDef="['loading']"
            [ngClass]="{ hide: dataSource !== null && !loading }"
            [class.loadingTable]="loading"></tr>
        <tr
            mat-footer-row
            *matFooterRowDef="['noData']"
            [ngClass]="{ hide: !(dataSource !== null && dataSource.data.length === 0 && !loading) }"></tr>
        <tr mat-footer-row *matFooterRowDef="['noRecords']" [ngClass]="{ hide: !noRecordsFound }"></tr>
        <tr
            mat-row
            *matRowDef="let element; columns: selectedColumns"
            class="example-element-row"
            [class.example-expanded-row]="expandedElement === element"
            [class.disabled]="element.disabled"
            [class.matTableError]="element.errorsCount && element.errorsCount > 0"
            [class.matTableWarning]="element.warningsCount && +element.warningsCount > 0"
            [class.badScore]="element.score !== undefined && element.score !== 100"
            (click)="onSingleClick(element)"
            (dblclick)="onDoubleClick(element)"></tr>
    </table>
</app-table-virtual-scroll-viewport>
<ng-container *ngIf="hidePaginator !== true && pagination?.value?.count > 0">
    <material-paginator
        [paginationSubject]="pagination"
        (fetchItemsInPage)="fetchItemsInPage.emit($event)"
        (refreshItemsWithNewPageSize)="refreshItemsWithNewPageSize.emit($event)"></material-paginator>
</ng-container>
